import React from 'react';
import './AlertTag.css';
import warningIcon from '../../assets/warning-alert-icon.png';
import errorIcon from '../../assets/error-alert-icon.png';
import invalidIcon from '../../assets/invalid-alert-icon.png';
import invalidElevatedInactiveIcon from '../../assets/invalid-alert-elevated-inactive-icon.png';
import warningActiveIcon from '../../assets/warning-alert-active-icon.png';
import errorActiveIcon from '../../assets/error-alert-active-icon.png';
import invalidActiveIcon from '../../assets/invalid-alert-active-icon.png';
import whiteXIcon from '../../assets/white-x-icon.png';
import blackXIcon from '../../assets/black-x-icon.png';

const iconMap = {
  "Warnings": {
    inactive: warningIcon,
    active: warningActiveIcon,
    closeIcon: blackXIcon
  },
  "Errors": {
    inactive: errorIcon,
    active: errorActiveIcon,
    closeIcon: whiteXIcon
  },
  "Required Fields": {
    inactive: invalidIcon,
    active: invalidActiveIcon,
    closeIcon: whiteXIcon
  }
};

// Alert tag component that displays validation status with count and active/inactive states
function AlertTag({ label, count, onClick, active, onClose, elevateRequiredFields }) {
  // Determine if Required Fields should use error styling
  const useErrorStyling = label === "Required Fields" && elevateRequiredFields;
  
  let icon;
  if (active) {
    icon = iconMap[label].active;
  } else {
    // Use elevated icon for Required Fields when elevated
    if (useErrorStyling && label === "Required Fields") {
      icon = invalidElevatedInactiveIcon;
    } else {
      icon = iconMap[label].inactive;
    }
  }
  
  const closeIcon = active ? iconMap[label].closeIcon : null;
  
  const baseIconClass = `${label.replace(' ', '-').toLowerCase()}-icon ${active ? 'active' : 'inactive'}`;
  
  const tagClassName = `alert-tag ${label.replace(' ', '-')} ${active ? 'active' : ''} ${useErrorStyling ? 'elevated-required-fields' : ''}`;
  const iconClassName = `alert-icon ${baseIconClass} ${useErrorStyling ? 'elevated-required-fields-icon' : ''}`;

  return (
    <div className={tagClassName} onClick={onClick}>
      <img src={icon} alt={`${label} Icon`} className={iconClassName} />
      <span className="alert-label">{label}</span>
      <span className="alert-count">({count})</span>
      {active && (
        <img
          src={closeIcon}
          alt="Close Icon"
          className="close-icon"
          onClick={(e) => {
            e.stopPropagation();
            if (onClose) onClose();
          }}
        />
      )}
    </div>
  );
}

export default AlertTag;